import React from 'react'

import { colors } from '@flowwai-frontend/shared/style-guide'

import { IconPropsType } from '../types'

const MarkerPin06Icon = (props: IconPropsType): React.ReactElement => {
   const { height = 20, stroke = colors['gray-700'], width = 20 } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         viewBox='0 0 20 20'
         fill='none'
      >
         <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M9.99992 3.33366C9.07944 3.33366 8.33325 4.07985 8.33325 5.00033C8.33325 5.9208 9.07944 6.66699 9.99992 6.66699C10.9204 6.66699 11.6666 5.9208 11.6666 5.00033C11.6666 4.07985 10.9204 3.33366 9.99992 3.33366ZM6.66658 5.00033C6.66658 3.15938 8.15897 1.66699 9.99992 1.66699C11.8409 1.66699 13.3333 3.15938 13.3333 5.00033C13.3333 6.55352 12.2709 7.85861 10.8333 8.22864V14.167C10.8333 14.6272 10.4602 15.0003 9.99992 15.0003C9.53968 15.0003 9.16658 14.6272 9.16658 14.167V8.22864C7.7289 7.85861 6.66658 6.55352 6.66658 5.00033ZM7.48426 10.9849C7.57305 11.4365 7.27894 11.8746 6.82735 11.9634C5.42601 12.2389 4.2907 12.6821 3.52886 13.1959C2.74862 13.7221 2.49992 14.2168 2.49992 14.5837C2.49992 15.087 2.99346 15.8202 4.44933 16.4754C5.82698 17.0953 7.78866 17.5003 9.99992 17.5003C12.2112 17.5003 14.1729 17.0953 15.5505 16.4754C17.0064 15.8202 17.4999 15.087 17.4999 14.5837C17.4999 14.2168 17.2512 13.7221 16.471 13.1959C15.7091 12.6821 14.5738 12.2389 13.1725 11.9634C12.7209 11.8746 12.4268 11.4365 12.5156 10.9849C12.6044 10.5333 13.0424 10.2392 13.494 10.328C15.0358 10.6312 16.4005 11.1381 17.4029 11.8141C18.3869 12.4778 19.1666 13.4128 19.1666 14.5837C19.1666 16.1514 17.7946 17.2932 16.2344 17.9952C14.596 18.7325 12.391 19.167 9.99992 19.167C7.6088 19.167 5.40382 18.7325 3.76539 17.9952C2.20519 17.2932 0.833252 16.1514 0.833252 14.5837C0.833252 13.4128 1.61297 12.4778 2.59692 11.8141C3.5993 11.1381 4.96399 10.6312 6.50582 10.328C6.95741 10.2392 7.39547 10.5333 7.48426 10.9849Z'
            fill={stroke}
         />
      </svg>
   )
}

export default MarkerPin06Icon
